import { BehaviorSubject } from 'rxjs';

const revisionNoticeModal$ = new BehaviorSubject(false);

const displayRevisionNoticeModal = (isShow: boolean) => {
	revisionNoticeModal$.next(isShow);
}

export const revisionNoticeService = {
	onRevisionNoticeModal$: revisionNoticeModal$.asObservable(),
	displayRevisionNoticeModal
};